import React from "react";
import { useTranslation } from "react-i18next";

import commonComponents from "../../../components/common";
import plansBillingComponents from "./components/plans-billing";

const SettingsPlansBilling = (props) => {
  const { PageHeader } = commonComponents;
  const {
    PlanInfo,
    Utilities,
    PaymentMethods,
    BillingDocuments
  } = plansBillingComponents;
  const { } = props;
  const { t } = useTranslation();
  
  return (
    <div className="plans-billing layout-content">
      <PageHeader
        title={t('plans_billing.title')}
        subtitle={t('plans_billing.description')}
        actions={[]}
      />
      <PlanInfo className="mt-6"/>
      <Utilities className="mt-6"/>
      <PaymentMethods className="mt-6"/>
      <BillingDocuments className="mt-6"/>
    </div>
  );
}

export default SettingsPlansBilling;